import { Card, CardContent, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme, clickable }) => ({
    height: 200,
    [theme.breakpoints.up('sm')]: {
        height: 220,
    },
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s ease-in-out',
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    '&:hover': clickable ? {
        transform: 'translateY(-4px)',
        boxShadow: theme.shadows[6],
    } : {},
    cursor: clickable ? 'pointer' : 'no-drop',
    opacity: clickable ? 1 : 0.7,
}));

const IconWrapper = styled(Box)(({ theme, color = 'primary' }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 60,
    height: 60,
    margin: '0 auto',
    borderRadius: '50%',
    background: `linear-gradient(135deg, ${theme.palette[color]?.main || theme.palette.primary.main}, ${theme.palette[color]?.dark || theme.palette.primary.dark})`,
    color: theme.palette[color]?.contrastText || theme.palette.primary.contrastText,
    marginBottom: theme.spacing(2),
}));

const CountTypography = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: '2rem',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
}));

/**
 * CardIcon - Componente reutilizable para tarjetas con icono
 * @param {Object} props
 * @param {React.ReactNode} props.icon - Icono a mostrar
 * @param {string} props.title - Título de la tarjeta
 * @param {string} props.description - Descripción de la tarjeta
 * @param {string|number} [props.count] - Número/contador opcional
 * @param {Function} [props.onClick] - Callback al hacer click
 * @param {string} [props.color] - Color del tema (primary, secondary, info, etc.)
 */
export const CardIcon = ({ 
    icon, 
    title, 
    description, 
    count, 
    onClick, 
    color = 'primary' 
}) => {
    const handleClick = () => {
        if (onClick && typeof onClick === 'function') {
            onClick();
        }
    };

    return (
        <StyledCard 
            onClick={handleClick} 
            clickable={!!onClick}
            elevation={onClick ? 2 : 1}
        >
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
                <IconWrapper color={color}>
                    {icon}
                </IconWrapper>
                <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {title}
                </Typography>
                {count !== undefined && (
                    <CountTypography variant="h4">
                        {count}
                    </CountTypography>
                )}
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.4 }}>
                    {description}
                </Typography>
            </CardContent>
        </StyledCard>
    );
};